<template>
  <div class="player_progress">
    <div class="position-relative">
      <div class="player_progress_static">
        <span class="text-22px">{{ loadType || '加载中...' }}</span>
        <span class="text-20px">{{ percentage.toFixed(2) }}%</span>
      </div>
      <el-progress :text-inside="false" :stroke-width="26" :percentage="percentage"></el-progress>
    </div>
  </div>
</template>
<script>
export default {
  props: ['percentage', 'loadType'],
}
</script>
<style lang="scss" scoped>
.player_progress {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  color: #019cff;
  width: 412px;
  height: 200px;
  transform: translate(-206px, -100px);
  &_static {
    font-size: 30px;
  }
}
::v-deep .el-progress {
  padding: 2px;
  border: 2px solid #027dfa;
  border-radius: 100px;
  &__text {
    display: none;
  }
  &-bar {
    margin-right: 0px;
    padding-right: 0px;
    &__inner {
      background: linear-gradient(45deg, #228bec, #2dfdff);
      box-shadow: 0 0 10px 6px #0078ff;
    }
    &__outer {
      height: 20px !important;
      background-color: rgba(0, 22, 82, 0.6);
      overflow: visible;
    }
  }
}
</style>
